var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOffHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.45455C12.5091 6.45455 14.5455 8.49091 14.5455 11C14.5455 11.6182 14.4182 12.2 14.1909 12.7364L16.8909 15.4364C18.3091 14.1818 19.4364 12.6909 20 11C18.4273 6.90909 14.5455 4 10 4C8.79091 4 7.62727 4.2 6.52727 4.56364L8.50909 6.54545C9.04545 6.32727 9.60909 6.45455 10 6.45455ZM1.81818 3.27273L3.89091 5.34545L4.32727 5.78182C2.76364 7.05455 1.52727 8.62727 0.909091 10.4C2.48182 14.4909 6.36364 17.4 10.9091 17.4C12.2545 17.4 13.5364 17.1545 14.7182 16.7091L15.1182 17.1091L17.7273 19.7273L18.9091 18.5455L3 2.09091L1.81818 3.27273ZM6.51818 7.97273L7.93636 9.39091C7.88182 9.58182 7.85455 9.78182 7.85455 10C7.85455 11.5091 9.07273 12.7273 10.5818 12.7273C10.8 12.7273 11.0091 12.7 11.2 12.6455L12.6182 14.0636C11.9909 14.3636 11.3 14.5455 10.5818 14.5455C8.07273 14.5455 6.03636 12.5091 6.03636 10C6.03636 9.28182 6.21818 8.60909 6.51818 7.97273ZM10.4364 7.29091L13.3 10.1545L13.3182 10C13.3182 8.49091 12.1 7.27273 10.5909 7.27273L10.4364 7.29091Z",
    fill: "#C6C9F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOffHover);
export default __webpack_public_path__ + "static/media/eye-off-hover.78bbd088788ec839de2647070cd27666.svg";
export { ForwardRef as ReactComponent };